import React from 'react'
import { Form, Spinner } from 'react-bootstrap'
import { DatePicker } from 'antd'
import { Button } from 'reactstrap'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'

dayjs.extend(customParseFormat)
const { RangePicker } = DatePicker
const dateFormat = 'YYYY-MM-DD'

export default function AdvanceFiltersForm({ 
    onSubmit, loading, register, errors, setValue, watch, reportType
}) {

    const rangePresets = [
        {
          label: 'Últimos 7 Días',
          value: [dayjs().add(-7, 'd'), dayjs()],
        },
        {
          label: 'Últimos 14 Días',
          value: [dayjs().add(-14, 'd'), dayjs()],
        },
        {
          label: 'Mes Actual',
          value: [dayjs().startOf('month'), dayjs().endOf('month')],
        },
        {
          label: 'Mes Pasado',
          value: [dayjs().add(-1, 'M').startOf('month'), dayjs().add(-1, 'M').endOf('month')],
        },
        {
          label: 'Mes Ante Pasado',
          value: [dayjs().add(-2, 'M').startOf('month'), dayjs().add(-2, 'M').endOf('month')],
        },
    ];

    return (
        <React.Fragment>
            <Form onSubmit={onSubmit}>
                <Form.Group className="form-group">
                    <Form.Label>Fecha de Envió de Campaña <span className='text-primary'>*</span></Form.Label>
                    <RangePicker 
                        presets={rangePresets}
                        value={[
                            dayjs(watch('sent_at_from'), dateFormat),
                            dayjs(watch('sent_at_until'), dateFormat)
                        ]}
                        onChange={(e, dates) => {
                            setValue('sent_at_from', dates[0])
                            setValue('sent_at_until', dates[1])
                        }}
                        allowClear={false}
                    />
                    <Form.Control {...register('sent_at_from', { required:true })} style={{display:'none'}} />
                    { errors.sent_at_from &&  <Form.Text className='text-warning'>Este campo es requerido</Form.Text>}
                    <Form.Control {...register('sent_at_until', { required:true })} style={{display:'none'}} />
                    { errors.sent_at_until &&  <Form.Text className='text-warning'>Este campo es requerido</Form.Text>}
                </Form.Group>
                { reportType === 'email_campaigns' && (
                    <Form.Group className="form-group">
                        <Form.Label>Método de Asignación <span className='text-primary'>*</span></Form.Label>
                        <Form.Control
                            as="select"
                            {...register('scope', {})}
                        >
                            <option value="">Cliente recibió campaña</option>
                            <option value="opened">Cliente abrió campaña</option>
                            <option value="clicked">Cliente hizo clic en campaña</option>
                        </Form.Control>
                    </Form.Group>
                )}
                <Form.Group className="form-group">
                    <Form.Label>ID Campañas Específica <small><em>(opcional)</em></small></Form.Label>
                    <Form.Control 
                        {...register('campaign_id', {})}
                        placeholder='Escriba aquí...'
                    />
                    <Form.Text className='text-muted'>Ingrese el ID de la campaña</Form.Text>
                </Form.Group>
                <Form.Group className="form-group">
                    <Form.Label>Código de Tienda <small><em>(opcional)</em></small></Form.Label>
                    <Form.Control 
                        {...register('store_code', {})}
                        placeholder='Escriba aquí...'
                    />
                </Form.Group>
                <Form.Group className="form-group">
                    <Form.Label>Nombre de Producto <small><em>(opcional)</em></small></Form.Label>
                    <Form.Control 
                        {...register('product_keyword', {})}
                        placeholder='Escriba aquí...'
                    />
                    <Form.Text className='text-warning'>Solo afecta tabla de productos vendidos</Form.Text>
                </Form.Group>
                <Form.Group className="form-group">
                    <Form.Label>Código de Tarifa <small><em>(opcional)</em></small></Form.Label>
                    <Form.Control 
                        {...register('rate_keyword', {})}
                        placeholder='Escriba aquí...'
                    />
                    <Form.Text className='text-warning'>Solo afecta tabla de tarifas vendidas</Form.Text>
                </Form.Group>
                <Button type="submit" color='primary' disabled={loading}>
                    { loading && <Spinner animation='border' size="sm" className='mr-5' /> }
                    Generar Reporte
                </Button>
            </Form>
        </React.Fragment>
    )
}